import script from "./questions.vue?vue&type=script&setup=true&lang=ts"
export * from "./questions.vue?vue&type=script&setup=true&lang=ts"

import "./questions.vue?vue&type=style&index=0&id=75b9fb81&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75b9fb81"]])

export default __exports__